import React, { Component } from 'react';
import 'react-toastify/dist/ReactToastify.css';

import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import {
  shortData,
} from '../../helpers';
import CustomTable from '../../components/CustomTable/CustomTable';
import { RowAction, RowActions } from '../../components/RowActions/RowActions';

const columns = [
  {
    id: 'Id', label: 'Id',
  },
  {
    id: 'ActivityType', label: 'Activity Type',
  },
  {
    id: 'action',
    label: 'Action',
  },
];

const useStyles = () => ({
  tablewo: {
    cursor: 'pointer',
    '&:hover': {
      background: '#eeeeee',
    },
  },
  mainContainer: {
    // The page container (components/PageContainer) owns padding and width.
    width: '100%',
    minWidth: 0,
  },
  buttonLink: {
    width: 20,
    height: 20,
    margin: 0,
    padding: 10,
  },
});

class table extends Component {
  render() {
    const {
      classes, handleShowEditForm, handleDeleteData, data,
      handleChangePage, handleChangeRowsPerPage, handleShowAddForm,
      //  handleViewLoanDetails,
    } = this.props;

    return (
      <div className={classes.mainContainer}>
        <CustomTable
          icons={[{ icon: AddCircleOutlineRoundedIcon, name: 'Add Config' }]}
          tableName='Activity Type Config'
          onIconClick={(key) => {
            handleShowAddForm && handleShowAddForm(key);
          }}
          tableHead={columns}
          itemComponent={data.length > 0 ? data.map((element, index) => (
            <TableRow
              className={classes.tablewo}
              tabIndex={-1}
              key={element.id}
              // onClick={(key) => { handleViewLoanDetails(key, element.id); }}
            >
              <TableCell>
                {index + 1}
              </TableCell>
              <TableCell>
                {shortData(element.activityType || '')}
              </TableCell>
              <TableCell>
                <RowActions>
                  <RowAction
                    kind='edit'
                    onClick={(key) => { handleShowEditForm && handleShowEditForm(key, element); }}
                  />
                  <RowAction
                    kind='delete'
                    onClick={(key) => { handleDeleteData && handleDeleteData(key, element.id); }}
                  />
                </RowActions>
              </TableCell>
            </TableRow>
          )) : null}
          count={1}
          rowsPerPage={0}
          page={1}
          handleChangePage={handleChangePage && handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage && handleChangeRowsPerPage}
        />
      </div>
    );
  }
}

export default withStyles(useStyles)(table);
